var map = {
	"./ios-cn-btn.png": "O88h",
	"./ios-de-btn.png": "g08G",
	"./ios-en-btn.png": "qybB",
	"./ios-es-btn.png": "Mhtu",
	"./ios-fr-btn.png": "yj3b",
	"./ios-pt-btn.png": "bJpU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MFI/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/ios ^\.\/ios\-.*\-btn\.png$
// module id = MFI/
// module chunks = 1